import { AxiosInstance } from "axios";
import { ApiService } from "../model/Api.model";
import { ITicketRequest } from "../interface/ticket/ITicketRequests";
import { ITicketRequestRequest } from "../interface/request/ITicketRequestRequest";
import { IWorkFlowResponse } from "../interface/response/IWorkFlowResponse";
import { ITicketRequestType } from "../interface/ticket/ITicketRequestType";

enum TicketRequestServiceEnum {
  base = "/",
  getByTradeId = "/by-trade",
  getTypes = "/categories",
  closeTicketRequest = "/close-ticket-request"
}

export default class TicketRequestService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/ticket/request");
  }

  public postCloseTicketRequest = async (ticketRequestId): Promise<any> =>
    await this.POST(TicketRequestServiceEnum.closeTicketRequest + "?ticketRequestId=" + ticketRequestId, null);

  public getTicketRequestsByTradeId = async (tradeId: number): Promise<ITicketRequest[]> => await this.GET(`${TicketRequestServiceEnum.getByTradeId}/${tradeId}`);
  public getTicketRequest = async (ticketRequestId: number): Promise<ITicketRequest> => await this.GET(`${TicketRequestServiceEnum.base}${ticketRequestId}`);
  public postTicketRequest = async (request: ITicketRequestRequest): Promise<IWorkFlowResponse> => await this.POST(TicketRequestServiceEnum.base, request);

  public getTicketRequestTypes = async (): Promise<ITicketRequestType[]> => await this.GET(`${TicketRequestServiceEnum.getTypes}`);
}
